const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/items/$id/changelog.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { httpClient } from "@/lib/http-client";
import { dehydrate } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/{-$locale}/items/$id/changelog")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      id
    } = params;
    const {
      queryClient
    } = context;
    await queryClient.prefetchQuery({
      queryKey: ["changelog", {
        id,
        page: 1
      }],
      queryFn: () => httpClient.get<Change[]>(`/items/${id}/changelog`).catch(() => null)
    });
    return {
      id,
      dehydratedState: dehydrate(queryClient)
    };
  }
});
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
};